import Base from "./Base"

class Granite extends Base {
}

export default new Granite("granites")
